export const EVENTS = {
  SPIN_THE_PRIZE: "SPIN_THE_PRIZE",
  RAFFLE_CANCELLED: "RAFFLE_CANCELLED",
  CONNECT: "connect",
  JOIN_RAFFLE: "joinRaffle",
  LEFT_RAFFLE: "leftRaffle",
};
